<template>
  <div class="addNewClass">
    <div class="content">
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>活动名称</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="21">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div class="flex">
                  <el-input
                    v-model="form.name"
                    placeholder="如：国庆满减活动，最多20字"
                    size="small"
                    class="marginR"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>活动时间</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-date-picker
            size="mini"
            v-model="getTime"
            type="daterange"
            value-format="yyyy-M-d"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>同步打标签</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="19">
                <el-checkbox v-model="tagChecked">给参与客户打标签</el-checkbox>
                <div v-if="tagChecked">
                  <el-select
                    v-model="tagValue"
                    multiple
                    placeholder="请选择标签"
                    size="mini"
                  >
                    <el-option
                      v-for="item in TagOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                    <!-- <el-option-group
                      v-for="group in TagOptions"
                      :key="group.id"
                      :label="group.name">
                      <el-option
                        v-for="item in group.valueArr"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-option-group> -->
                  </el-select>
                  <el-button type="text" class="marginRL" @click="getLabelList"
                    >刷新</el-button
                  >
                  <router-link
                    target="_blank"
                    to="/apply/mallManagement/mall/commodityLabel"
                  >
                    <el-button type="text" class="marginRL">添加</el-button>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>活动商品</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="color marginSX">
            单个商品仅同时参与一个满减/送活动；若活动商品中存在分销商品，分销商品的优惠将有分销商承担。
          </div>
          <div class="marginSX">
            <el-radio v-model="form.activity_type" label="1">
              全部商品参加
            </el-radio>
          </div>
          <div class="marginSX">
            <el-radio v-model="form.activity_type" label="2">
              <div style="display:inline-block">
                <div class="">
                  <div style="padding: 12px 0">指定商品参加</div>
                </div>
              </div>
            </el-radio>
            <div v-if="form.activity_type == '2'" style="margin: 0px 20px">
              <div v-if="commonPList.length" class="goods_line">
                <div>已选择</div>
                <div class="goods_name">{{ commonPNames }}</div>
                <div>
                  等<span>{{ commonPList.length }}</span
                  >件商品
                </div>
              </div>
              <el-button
                @click="checkShow(1)"
                type="text"
                v-if="form.activity_type == '2'"
                >选择商品</el-button
              >
            </div>
          </div>
          <!-- <div class="marginSX">
            <el-radio v-model="form.activity_type" label="2">
              指定商品参加
            </el-radio>
          </div> -->
          <div class="marginSX">
            <el-radio v-model="form.activity_type" label="3">
              <div style="display:inline-block">
                <div class="flex">
                  <div>指定商品不参加</div>
                </div>
              </div>
            </el-radio>
            <div v-if="form.activity_type == '3'" style="margin: 0px 20px">
              <div
                v-if="assignPList.length"
                class="goods_line"
                style="padding: 12px 0 0 5px "
              >
                <div>已选择</div>
                <div class="goods_name marginSX">{{ assignPNames }}</div>
                <div>
                  等<span>{{ assignPList.length }}</span
                  >件商品
                </div>
              </div>
              <el-button
                @click="checkShow(0)"
                type="text"
                v-if="form.activity_type == '3'"
                >选择商品</el-button
              >
            </div>
          </div>
          <!-- <div class="marginSX">
            <el-radio  v-model="form.activity_type" label="3">
              指定商品不参加
            </el-radio>
          </div> -->
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>活动页规则展示</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="marginSX">
            <el-radio v-model="form.is_cover" label="0">
              默认文案
            </el-radio>
          </div>
          <div class="color" style="margin: 10px 25px">
            根据优惠设置自动生成文案，在活动页顶部展示
          </div>
          <div class="marginSX">
            <el-radio v-model="form.is_cover" label="1">
              自定义图片
            </el-radio>
            <div class="color" style="margin: 10px 25px">
              用自制的图片在活动页 展示（默认无文案）
            </div>
          </div>
          <el-button type="text">查看示例</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="40" v-if="form.is_cover == '1'">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>上传图片</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-upload
            name="image"
            :data="imgdata"
            class="avatar-uploader"
            :show-file-list="false"
            accept="image/jpeg,image/gif,image/png"
            action="https://www.58zltc.com/api/Upload/uploads/"
            :on-success="handleLogoSuccess"
            :before-upload="beforeLogoUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>活动设置</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="marginSX">
            <el-radio v-model="form.type" label="1">
              阶梯满减
            </el-radio>
          </div>
          <!-- 满减 -->
          <div class="box" v-for="(item, index) in numRules" :key="index">
            <div class="flex">
              <div style="padding:5px 10px 5px 28px;">优惠门槛:</div>
              <div style="height:28px;" v-if="fullType == 1">
                满<input
                  class="radioInput"
                  type="number"
                  v-model="item.total_money"
                  oninput="if(value  <= 0 ){value = 0}"
                />元
              </div>
              <div style="height:28px;" v-else>
                满<input
                  class="radioInput"
                  type="number"
                  v-model="item.total_num"
                  oninput="if(value  <= 0 ){value = 0}"
                />件
              </div>
            </div>
            <div class="flex marginSX">
              <div style="padding:5px 10px 5px 28px;">优惠内容:</div>
              <div class="">
                <el-checkbox v-model="orderStatus">订单金额优惠</el-checkbox>
                <div style="padding-left: 20px;">
                  <div class="marginSX" v-if="fullType == '1'">
                    <el-radio v-model="orderLabel" label="1">
                      减<input
                        class="radioInput"
                        type="number"
                        v-model="item.dec_price"
                        oninput="if(value  <= 0 ){value = 0}"
                      />元
                    </el-radio>
                  </div>
                  <div class="marginSX" v-if="fullType == '2'">
                    <el-radio v-model="orderLabel" label="2">
                      减<input
                        class="radioInput"
                        type="number"
                        v-model="item.free_num"
                        oninput="if(value  <= 0 ){value = 0}"
                      />件
                    </el-radio>
                  </div>
                  <div
                    class="marginSX"
                    style="padding-left: 20px;"
                    v-if="orderLabel == '2'"
                  >
                    <el-radio v-model="item.payment_status" label="1"
                      >按最高商品价格</el-radio
                    >
                    <el-radio v-model="item.payment_status" label="2"
                      >按最低商品价格</el-radio
                    >
                  </div>
                  <div style="height:28px;">
                    <el-radio v-model="orderLabel" label="3">
                      打<input
                        class="radioInput"
                        type="number"
                        v-model="item.zhe_num"
                        oninput="if(value  <= 0 ){value = 0}"
                      />折
                    </el-radio>
                    <!--  v-if="fullType== '2'" -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-button type="text" @click="addRules(1)">新增条件</el-button>
          <el-button type="text" @click="addRules(0)">减少条件</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top:0" :span="19"> </el-row>
      <el-row :gutter="20" justify="end" type="flex" style="margin-bottom:40px">
        <el-col :span="4">
          <el-button type="primary" @click="submit">
            <span>提交</span>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="integral_product"
      ></selectCommodity>
    </el-dialog>
  </div>
</template>

<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { mapGetters } from "vuex";
import {
  addfullReduct,
  editfullReduct,
  detailfullReduct
} from "@/api/fullReduction";
import { labelList } from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    selectCommodity
  },
  data() {
    return {
      numRules: [
        {
          dec_price_status: "0",
          total_money: "0",
          dec_price: "0",
          // 件
          free_status: "0",
          total_num: "0",
          free_num: "0",
          // 折
          zhe_status: "0",
          zhe_num: "0",
          // 最低/高价
          payment_status: "1"
        }
      ],
      orderStatus: true,
      orderLabel: "1",
      tagValue: [],
      TagOptions: [],
      getTime: [],
      imgdata: {},
      tagChecked: false,
      showSelecter: false, //显示商品选择
      // ids: "", //选择的商品id字符串
      sList: [], //已选择的商品列表
      commonPId: "",
      commonPList: [],
      commonPNames: "",
      assignPId: "",
      assignPList: [],
      assignPNames: "", //已选择的商品名
      imageUrl: "",
      checkShowId: 1,
      jude: 0,
      integral_product: 0, //0 正常商品 1 积分商品
      fullType: "1",
      form: {
        name: "",
        is_tags: 0,
        tag_ids: "",
        activity_type: "1",
        goods_ids: "",
        is_cover: "0",
        cover: "", //图片id
        type: "1", //阶梯满减
        full_type: "1",
        discount_status: "1",
        // 钱
        dec_price_status: "0",
        total_money: "0",
        dec_price: "0",
        // 件
        free_status: "0",
        total_num: "0",
        free_num: "0",
        // 折
        zhe_status: "0",
        zhe_num: "0",

        // 高低
        payment_status: "1",
        start_time: "",
        end_time: "",
        full_type: ""
      }
    };
  },
  mounted() {
    this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1"
    };
    if (this.$route.query.idE) {
      this.jude = this.$route.query.idE;
      this.getDetail();
    }
    if (this.$route.query.fullType) {
      this.fullType = this.$route.query.fullType;
      this.orderLabel = String(this.fullType);
      this.getDetail();
    }
    // 标签
    this.getLabelList();
  },
  methods: {
    // 新增条件
    addRules(type) {
      if (type == 1) {
        var obj = {
          dec_price_status: "0",
          total_money: "0",
          dec_price: "0",
          // 件
          free_status: "0",
          total_num: "0",
          free_num: "0",
          // 折
          zhe_status: "0",
          zhe_num: "0",
          // 最低/高价
          payment_status: "1"
        };
        this.numRules.push(obj);

        console.log("type", type);
      } else {
        this.numRules.pop();
        // console.log(this.numRules.pop());
      }
    },
    checkShow(index) {
      console.log("wobneidianji", index);
      this.showSelecter = true;
      this.checkShowId = index;
      console.log("integral_product", this.integral_product);
      if (index == 1) {
        this.sList = this.commonPList;
      } else {
        this.sList = this.assignPList;
      }
    },
    // 选择商品
    getCommod(data) {
      console.log(data);
      var ids = "",
        name = "";
      data.forEach(item => {
        ids += item.id + ",";
        name += item.name + ",";
      });
      ids = ids.substring(0, ids.length - 1);
      name = name.substring(0, name.length - 1);
      if (this.checkShowId == 1) {
        this.commonPId = ids;
        this.commonPList = data;
        this.commonPNames = name;
      } else {
        this.assignPId = ids;
        this.assignPList = data;
        this.assignPNames = name;
      }
      this.showSelecter = false;
    },
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.cover = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      console.log("编辑内容", value);
      // this.form.textCon = value;
    },

    submit() {
      if (this.form.name == "") {
        this.$message("请填写活动名称");
        return false;
      }
      if (this.getTime.length == 0) {
        this.$message("请选择活动时间");
        return;
      } else {
        this.form.start_time = new Date(this.getTime[0]).getTime() / 1000;
        this.form.end_time = new Date(this.getTime[1]).getTime() / 1000;
      }
      // tagChecked
      if (this.tagChecked) {
        if (this.tagValue.length > 0) {
          this.form.tag_ids = this.tagValue.join(",");
        } else {
          this.$message("请选择标签");
          return false;
        }
      }
      this.form.is_tags = this.tagChecked == true ? 1 : 0;
      if (this.form.activity_type == "2") {
        if (this.commonPList.length == 0) {
          this.$message("请选择指定商品");
          return false;
        } else {
          this.form.goods_ids = this.commonPId;
        }
      }
      if (this.form.activity_type == "3") {
        if (this.assignPList.length == 0) {
          this.$message("请选择不参加的商品");
          return false;
        } else {
          this.form.goods_ids = this.assignPId;
        }
      }
      // 自定义文案
      if (this.form.is_cover == "1" && this.imageUrl == "") {
        this.$message("请上传自定义文案!");
        return false;
      }
      // 优惠规则
      switch (this.orderLabel) {
        case "1":
          this.form.dec_price_status = "1";
          break;
        case "2":
          this.form.free_status = "1";
          break;
        case "3":
          this.form.zhe_status = "1";
          break;
      }
      this.form.full_type = this.fullType;
      let data = {
        full_type: this.form.full_type,
        name: this.form.name,
        is_tags: this.form.is_tags,
        tag_ids: this.form.tag_ids,
        activity_type: this.form.activity_type,
        goods_ids: this.form.goods_ids,
        is_cover: this.form.is_cover,
        cover: this.form.cover,
        type: this.form.type,
        dec_price_status: this.form.dec_price_status,
        total_money: this.form.total_money,
        dec_price: this.form.dec_price,
        free_status: this.form.free_status,
        total_num: this.form.total_num,
        free_num: this.form.free_num,
        zhe_status: this.form.zhe_status,
        zhe_num: this.form.zhe_num,
        payment_status: this.form.payment_status,
        start_time: this.form.start_time, //
        end_time: this.form.end_time, //
        token: this.token,
        app_id: this.app_id
      };
      console.log("提交数据", data);

      if (this.jude == 0) {
        addfullReduct(data).then(res => {
          console.log("保存活动", res);

          if (res.code == 400) {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          }
        });
      } else {
        data.id = this.jude;
        editfullReduct(data).then(res => {
          console.log("编辑提交", res);
          if (res.code == 0) {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          }
        });
      }
    },
    // 商品详情
    getDetail() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      };
      detailfullReduct(data).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.getTime = [];
          this.getTime.push(this.form.start_time);
          this.getTime.push(this.form.end_time);
          // 标签
          this.tagValue = this.form.tag_ids.split(",");

          if (this.tagValue.length > 0) {
            this.tagChecked = true;
            this.TagOptions = this.form.tags;
            for (var i in this.tagValue) {
              this.tagValue[i] = this.tagValue[i] * 1;
            }
          }
          //活动商品
          if (this.form.activity_type == 2) {
            this.commonPList = this.form.goods.data;
            var listdata = [];
            this.commonPList.forEach(item => {
              listdata.push(item.name);
            });
            this.commonPNames = listdata.join(",");

            this.commonPId = this.form.goods_ids;
          } else if (this.form.activity_type == 3) {
            this.assignPList = this.form.goods.data;
            this.assignPId = this.form.goods_ids;
            var listdata = [];
            this.assignPList.forEach(item => {
              listdata.push(item.name);
            });
            this.assignPNames = listdata.join(",");
          }

          if (this.form.is_cover == 1) {
            this.imageUrl = this.form.cover_url;
          }

          // 优惠
          if (this.form.dec_price_status == 1) {
            this.orderLabel = "1";
          }
          if (this.form.free_status == 1) {
            this.orderLabel = "2";
          }
          if (this.form.zhe_status == 1) {
            this.orderLabel = "3";
          }
          //活动商品
          this.form.activity_type = String(this.form.activity_type);
          //默认文案
          this.form.is_cover = String(this.form.is_cover);
          // 阶梯满减
          this.form.type = String(this.form.type);
          console.log("xiangq ", this.getTime);
        }
        console.log("活动详情", res);
      });
    },
    // 获取列表
    getLabelList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id
      };
      labelList(data).then(res => {
        console.log("标签列表", res);
        let data = res.data;
        this.TagOptions = data;
        for (var i = 0; i < data.length; i++) {
          this.TagOptions[i].valueArr = data[i].value.split(",");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-start;
}
.color {
  color: #909399;
  font-size: 10px;
}

.radioInput {
  height: 28px;
  margin: 0 5px;
  width: 100px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.radioInputM {
  height: 28px;
  margin-right: 5px;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.marginR {
  margin-right: 5px;
}
.marginRL {
  margin: 0 5px;
}
.marginSX {
  margin: 10px 0;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    overflow: auto;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      font-size: 14px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
